/**
 * Science — Resin Regeneration and Reuse: frontend behaviour.
 *
 * Blur-reveal entrance for the left text column and the two cards. Entrance
 * plays once. The card :hover lift lives in CSS.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-resin-regeneration]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const leftEls = [
			section.querySelector('.gv-resin-regeneration__eyebrow'),
			section.querySelector('.gv-resin-regeneration__title'),
			section.querySelector('.gv-resin-regeneration__pills'),
			section.querySelector('.gv-resin-regeneration__lead'),
		].filter(Boolean);

		const cards = Array.from(section.querySelectorAll('[data-resin-regeneration-card]'));

		if (reduced) {
			[...leftEls, ...cards].forEach((el) => {
				el.style.opacity = '1';
				el.style.filter = 'none';
				el.style.transform = 'none';
			});
			return;
		}

		gsap.set(leftEls, { opacity: 0, y: 20, filter: 'blur(10px)' });
		gsap.set(cards, { opacity: 0, y: 22, filter: 'blur(12px)' });

		const play = () => {
			const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
			leftEls.forEach((el, i) => {
				tl.to(el, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7 }, i * 0.1);
			});
			// clearProps:transform so GSAP's leftover inline transform doesn't
			// override the CSS :hover lift.
			tl.to(cards, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, stagger: 0.12, clearProps: 'transform' }, 0.2);
		};

		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					io.unobserve(entry.target);
					play();
				});
			},
			{ rootMargin: '0px 0px -15% 0px', threshold: 0.1 }
		);
		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
